module.exports = __webpack_public_path__ + "static/img/gift-box-effect-yellow.61c52fc.png";